import { createSlice } from "@reduxjs/toolkit";

import { getHistoryThunk } from "state/action/history";

// Initial state
const initialState = {
  // Get History inisial state
  getHistory: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // History object value
  history_object_value: "",
};

export const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    setGetHistoryObjectValue: (state, action) => {
      return {
        ...state,
        history_object_value: action.payload,
      };
    },
    setCreateHistoryInputBody: (state, action) => {
      return {
        ...state,
        createHistoryInputBody: action.payload,
      };
    },
    setSelectedHistory: (state, action) => {
      return {
        ...state,
        selectedHistory: action.payload,
      };
    },
    // note: clear state
    setClearGetHistoryObjectValue: (state, _) => {
      return {
        ...state,
        history_object_value: "",
      };
    },
    setClearCreateHistoryInputBody: (state, _) => {
      return {
        ...state,
        createHistoryInputBody: {
          property: "",
          name: "",
          code: "",
          yearContructed: "",
          amenities: "",
          description: "",
          isMall: false,
        },
      };
    },
    setClearGetHistory: (state, _) => {
      return {
        ...state,
        getHistory: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateHistory: (state, _) => {
      return {
        ...state,
        createHistory: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateHistory: (state, _) => {
      return {
        ...state,
        updateHistory: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteHistory: (state, _) => {
      return {
        ...state,
        deleteHistory: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllHistoryState: (state, _) => {
      return {
        ...state,
        // Get History inisial state
        getHistory: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },

        // History object value
        history_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get History reducer
      .addCase(getHistoryThunk.pending, (state, _) => {
        return {
          ...state,
          getHistory: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getHistoryThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getHistory: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getHistoryThunk.rejected, (state, action) => {
        return {
          ...state,
          getHistory: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const historyAction = {
  ...historySlice.actions,
  getHistoryThunk,
};

export function selectHistoryObjectValue(state) {
  return state?.history?.history_object_value;
}

export function selectHistory(state) {
  return state?.history;
}

export default historySlice.reducer;
